import { useTranslation } from '@flecto/translations'

import { FormCheckout } from '../../components/FormCheckout/FormCheckout'
import { Page } from '../../components/Page/Page'
import { SectionCheckout } from '../../components/SectionCheckout/SectionCheckout'
import { useStoreDetails } from '../../hooks/useStoreDetails'

export function PageCheckout() {
  const { t } = useTranslation('store', { keyPrefix: 'store-page-checkout' })
  const store = useStoreDetails()

  return (
    <Page
      htmlTitle={t('html_title', { store: store?.name })}
      htmlMetaDescription={t('html_meta_description')}
      htmlMetaOgTitle={t('html_meta_og_title', { store: store?.name })}
      htmlMetaOgDescription={t('html_meta_og_description')}
      withHeaderBasket={false}
      withHeaderDates={false}
      enableRobots={false}
    >
      <Page.Section title={t('title')}>
        <FormCheckout id='form-checkout'>
          <SectionCheckout mt='md' />
        </FormCheckout>
      </Page.Section>
    </Page>
  )
}
